export default "__VITE_ASSET__f1b7315e__"